export default __webpack_public_path__ + "static/media/dinner2.c2b0a1b1.png";